import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import useLecutre from '../../../hooks/leacture-detail/useLecture';
import { LECTURE_SCENARIO_STEPS } from '../../../constants/lectureScenario';

function Lecture() {
  const navigate = useNavigate();
  const { lectureList, loaded } = useLecutre();

  const openStep = (lectureId, step) => {
    navigate(`/lecture/${lectureId}?step=${step}`);
  };

  return (
    <Page>
      <Head>
        <Kicker>학습</Kicker>
        <Title>한 문제를 다섯 단계로 끝냅니다</Title>
        <Lead>풀이, 강의, AI 첨삭, 강사 첨삭, 리라이팅 순서로 진행합니다.</Lead>
      </Head>

      {lectureList.map((lecture) => (
        <Card key={lecture.id}>
          <CardTop>
            <div>
              <CardName>{lecture.name}</CardName>
              <CardMeta>논술 첨삭</CardMeta>
            </div>
            <Continue type="button" onClick={() => openStep(lecture.id, 1)}>
              이어서 하기
            </Continue>
          </CardTop>
          <Steps>
            {LECTURE_SCENARIO_STEPS.map((step) => (
              <Step key={step.id} type="button" onClick={() => openStep(lecture.id, step.id)}>
                <StepNum>0{step.id}</StepNum>
                <StepTitle>{step.title}</StepTitle>
                <StepText>{step.subtitle}</StepText>
              </Step>
            ))}
          </Steps>
        </Card>
      ))}

      {loaded && lectureList.length === 0 && (
        <Empty>
          <strong>등록된 문제가 없습니다</strong>
          <span>강의가 열리면 이곳에서 다섯 단계를 이어서 진행합니다.</span>
        </Empty>
      )}
    </Page>
  );
}

export default Lecture;

const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 1040px;
  margin: 0 auto;
`;

const Head = styled.header`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 4px;
`;

const Kicker = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #d9412b;
`;

const Title = styled.h1`
  margin: 0;
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #1d2340;
`;

const Lead = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: #6f6a5c;
`;

const Card = styled.article`
  background: #fff;
  border: 1px solid #e7e1d3;
  border-radius: 4px;
  box-shadow: 6px 6px 0 #e9e2d0;
`;

const CardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 22px 0;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const CardName = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #1d2340;
`;

const CardMeta = styled.p`
  margin: 4px 0 0;
  font-size: 13px;
  color: #6f6a5c;
`;

const Continue = styled.button`
  flex-shrink: 0;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #fff;
  background: #1d2340;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: #2c3561;
  }
`;

const Steps = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
  padding: 18px 22px 22px;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;

const Step = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-height: 112px;
  padding: 14px 12px;
  text-align: left;
  color: #1d2340;
  background: #f8f5ee;
  border: 1px solid #e7e1d3;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    border-color: #1d2340;
    background: #fff;
  }
`;

const StepNum = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #d9412b;
`;

const StepTitle = styled.span`
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.02em;
`;

const StepText = styled.span`
  font-size: 12px;
  line-height: 1.45;
  color: #6f6a5c;
`;

const Empty = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 36px 24px;
  background: #fff;
  border: 1px dashed #e7e1d3;
  border-radius: 4px;
  color: #6f6a5c;

  strong {
    color: #1d2340;
    font-size: 16px;
  }
`;
